import { Route, Routes } from "react-router-dom";
import { useEffect, useState, lazy, Suspense } from "react";
import "./assets/styles/index.scss";
import { useCookies } from "react-cookie";
import { useAuth } from "./contexts/AuthContext";
const Landing = lazy(() => import("./pages/Landing"));
const SignUp = lazy(() => import("./pages/SignUp"));
const LogIn = lazy(() => import("./pages/LogIn"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Loading = lazy(() => import("./pages/Loading"));
const NotFound = lazy(() => import("./pages/NotFound"));
const ActivateEmail = lazy(() => import("./pages/ActivateEmail"));
const EmailActivated = lazy(() => import("./pages/EmailActivated"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Search = lazy(() => import("./pages/Search"));

function Router() {
  const [cookies] = useCookies(["accessToken"]);
  const [isLoading, setIsLoading] = useState(cookies.accessToken);
  const { isLogged, getAccountInfo, accountInfo, lang } = useAuth();

  const root = document.getElementById("root");
  if (lang === "ar") {
    root.classList = "ar";
  } else {
    root.classList = "";
  }

  useEffect(() => {
    if (getAccountInfo.isFetched) {
      setIsLoading(false);
    }
  }, [getAccountInfo]);

  if (isLoading) return <Loading />;
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<Loading />}>
            {!isLogged ? <Landing /> : <Dashboard />}
          </Suspense>
        }
      >
        <Route path=":params" element={<Dashboard />} />
        <Route
          path="/clinic/:clinicParams"
          element={
            <Suspense fallback={<Loading />}>
              {!isLogged ? (
                <NotFound />
              ) : accountInfo.role === "DOCTOR" ? (
                <Dashboard />
              ) : (
                <NotFound />
              )}
            </Suspense>
          }
        />
        <Route
          path="/patient/:patientId"
          element={
            <Suspense fallback={<Loading />}>
              {!isLogged ? (
                <NotFound />
              ) : accountInfo.role === "DOCTOR" ? (
                <Dashboard />
              ) : (
                <NotFound />
              )}
            </Suspense>
          }
        />
      </Route>
      <Route
        path="/signup/"
        element={
          <Suspense fallback={<Loading />}>
            <SignUp />
          </Suspense>
        }
      />
      <Route
        path="/login"
        element={
          <Suspense fallback={<Loading />}>
            <LogIn />
          </Suspense>
        }
      />
      <Route
        path="/activate-email"
        element={
          <Suspense fallback={<Loading />}>
            <ActivateEmail />
          </Suspense>
        }
      />
      <Route
        path="/welcome"
        element={
          <Suspense fallback={<Loading />}>
            <EmailActivated />
          </Suspense>
        }
      />
      <Route
        path="/reset"
        element={
          <Suspense fallback={<Loading />}>
            <ResetPassword />
          </Suspense>
        }
      />
      <Route
        path="/search"
        element={
          <Suspense fallback={<Loading />}>
            <Search />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<Loading />}>
            <NotFound />
          </Suspense>
        }
      />
    </Routes>
  );
}

export default Router;
